import React from 'react';
import { Button } from 'components/button/Button';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal, selectIsModalLoading } from 'reducers/modal';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n/i18n';

type ReusePreviousResultsModalProps = {
  data: {
    takeNewTestFunction: () => void;
    reusePreviousResultsFunction: () => void;
    testType?: 'PQ' | 'SJT' | 'AbilityTest';
  };
};

const ReusePreviousResultsModal: React.FC<ReusePreviousResultsModalProps> = ({
  data,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('Candidate+Journey+-+PQTest', { i18n });

  const isLoading = useSelector(selectIsModalLoading);

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const handleTakeNewTest = () => {
    data.takeNewTestFunction();
    handleCloseModal();
  };

  const handleReusePreviousResults = () => {
    if (!isLoading) {
      data.reusePreviousResultsFunction();
    }
  };

  const modalMessage = t('ReusePreviousResults_Message');
  const redoAssessmentText = t('ReusePreviousResults_RedoAssessment');
  const processingText = t('ReusePreviousResults_Processing');
  const reusePreviousResultsText = t('ReusePreviousResults_ReuseResults');

  return (
    <div className="ReusePreviousResultsModal">
      <div className="Content">
        <p>
          {modalMessage}
        </p>
      </div>
      <div className="ModalFooter">
        <Button
          priority="tertiary"
          type="button"
          onClick={handleTakeNewTest}
          disabled={isLoading}
        >
          {redoAssessmentText}
        </Button>
        <Button
          priority="primary"
          type="submit"
          onClick={handleReusePreviousResults}
          disabled={isLoading}
        >
          {isLoading ? processingText : reusePreviousResultsText}
        </Button>
      </div>
    </div>
  );
};

export { ReusePreviousResultsModal };
